// extracted by mini-css-extract-plugin
export default {"DeleteBtn":"DeleteBtn_DeleteBtn__CI7kd"};